/* =============================================================================
   hd-nav-user.js —— 顶栏「身份区」（头像 + 昵称 + 我的下拉）   2026-10-14
   -----------------------------------------------------------------------------
   数据源：localStorage `hdCreatorProfile_v1` = {nick, email, list, listTouched, ts, skip}
     —— 与设计台 onboarding（sections/design-canvas.liquid 的 hdcoSaveObj）以及
        /pages/my-designs **同一份**，天然同步（禁第二份实现）。

   口径：
     · 有 nick ⇒ 显示 nick；只有 email ⇒ 退回 email 的 @ 前段；两者都无 ⇒ 未登录态。
     · 头像 = **昵称首字母彩圆**（服务端虽已有 design_users.avatar_url / POST /designers/avatar，
       但前端从未调用、数据全空且无上传入口 ⇒ 本轮不做真头像）。
     · 「我的」三项：My Designs（原生 <a>）/ Verify（跳设计台 ?signup=1 弹注册窗）/ Log out。
     · 退出 = **只清 nick + email**（保留 list / listTouched / ts / skip 等偏好）。

   交互：
     · 点「头像 + 昵称」→ /pages/my-designs（原生 <a>，无需 JS）
     · 点右侧 ⌄ → 开/关下拉；点外部 / Esc 关闭

   🔴 全站可用（首页/目录/商品页都有导航）⇒ **不用** window.__hdAct ——
      它只在 sections/design-canvas.liquid 里定义，其它页根本不存在。
      改走 **document 级事件委托 + composedPath()**（翻译插件会把按钮包进 <font>、
      直绑的监听器会被克隆丢失；委托不受影响，本仓已踩过）。
   ============================================================================= */
(function () {
  'use strict';

  var KEY = 'hdCreatorProfile_v1';
  /* 彩圆底色：昵称 → 固定色板（同一个人永远同色）。取品牌紫粉 + 常用辅助色。 */
  var PALETTE = ['#7C3AED', '#EC4899', '#0EA5E9', '#10B981', '#F59E0B', '#EF4444', '#8B5CF6', '#14B8A6'];
  /* 头像/昵称的**权威来源**（与 /pages/my-designs 的 avShow 同一接口）。站点唯一 bridge 地址。 */
  var BRIDGE = 'https://bridge.highdeep.net';

  function q(id) { return document.getElementById(id); }
  function load() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function store(o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) { } }
  function hash(s) { var h = 0; s = String(s || ''); for (var i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0; return h; }

  /* 显示名：昵称优先，退回邮箱前段（与 /pages/my-designs 的「Hi <nick>」同源）。 */
  function nameOf(p) {
    var n = String((p && p.nick) || '').trim();
    if (n) return n;
    var e = String((p && p.email) || '').trim();
    return e ? e.split('@')[0] : '';
  }

  /* 头像绘制：有真头像用 <img>，否则昵称首字母彩圆（与 my-designs 的 avPaint 同款口径）。 */
  function paintAvatar(av, name, url) {
    if (!av) return;
    var u = String(url || '');
    if (/^https?:\/\//.test(u)) {
      av.innerHTML = '<img src="' + u + '" alt="" decoding="async">';
      av.style.background = 'transparent';
    } else {
      av.textContent = (String(name || '?').charAt(0) || '?').toUpperCase();
      av.style.background = PALETTE[hash(String(name || '').toLowerCase()) % PALETTE.length];
    }
  }

  /* 2026-10-14（用户裁决·修正）：顶栏「Verify」**直接跳身份页** /pages/my-designs ——
     注册/验证都在那一页完成（老用户出欢迎态、新用户原地弹注册弹窗）。
     原先那版「原地弹窗」已撤 —— 弹窗留给该页自己用。 */
  function openSignup() {
    location.href = '/pages/my-designs';
  }

  var isOpen = false;
  function setOpen(on) {
    var menu = q('navUserMenu'), caret = q('navUserCaret');
    isOpen = !!on;
    if (menu) { if (isOpen) menu.removeAttribute('hidden'); else menu.setAttribute('hidden', ''); }
    if (caret) caret.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
  }

  function render() {
    var p = load(), name = nameOf(p), logged = !!name;
    var idEl = q('navUserId'), caret = q('navUserCaret'), signup = q('navUserSignup'),
        av = q('navUserAv'), nm = q('navUserNm');
    if (!idEl) return;   /* 本页没有身份区（理论上不该发生，导航在 layout 里） */

    if (logged) {
      paintAvatar(av, name, p.avatar || '');   /* 先用本地缓存头像立即出图（有缓存不闪首字母） */
      if (nm) nm.textContent = name;
      idEl.style.display = '';
      if (caret) caret.style.display = '';
      if (signup) signup.style.display = 'none';
      /* 服务端校正：真头像 + 权威昵称（用户在 /pages/my-designs 换过头像就走这里同步）。
         刻意**不缓存** —— 页面切换各查一次即可保证「我的设计」里刚换的头像立即可见。
         ⚠️ 回调里重新 load() 比对 email：期间用户可能已退出 / 换号，不能拿旧响应覆盖。 */
      var email = String(p.email || '').trim();
      if (email) {
        (function (want) {
          fetch(BRIDGE + '/designers/profile?email=' + encodeURIComponent(want), { cache: 'no-store' })
            .then(function (r) { return r.json(); })
            .then(function (d) {
              if (!d || !d.success) return;
              var cur = load();
              if (String(cur.email || '').trim() !== want) return;
              var n2 = String(d.nickname || '').trim() || name;
              var nmEl = q('navUserNm');
              if (nmEl && n2) nmEl.textContent = n2;
              var u = String(d.avatar || '');
              if (u !== String(cur.avatar || '')) { cur.avatar = u; store(cur); }
              paintAvatar(q('navUserAv'), n2, u);
            })
            .catch(function () { /* 静默：拿不到就保持彩圆，不影响主流程 */ });
        })(email);
      }
    } else {
      idEl.style.display = 'none';
      if (caret) caret.style.display = 'none';
      if (signup) signup.style.display = '';
    }
    setOpen(false);
  }

  /* 事件路径：优先 composedPath（翻译/Shadow 场景下 e.target 可能已脱链），退化手工爬 parentNode。 */
  function pathOf(e) {
    try { if (e.composedPath) return e.composedPath(); } catch (err) { }
    var t = e.target, a = [];
    while (t) { a.push(t); t = t.parentNode; }
    return a;
  }

  /* 委托（捕获阶段）：翻译插件克隆按钮、或后代 stopPropagation 都拦不住。 */
  document.addEventListener('click', function (e) {
    var path = pathOf(e), i;
    var hit = function (id) { for (var k = 0; k < path.length; k++) { var n = path[k]; if (n && n.id === id) return true; } return false; };
    var root = q('navUser'), inRoot = false;
    if (!root) return;
    for (i = 0; i < path.length; i++) { if (path[i] === root) { inRoot = true; break; } }

    if (hit('navUserCaret')) { e.stopPropagation(); setOpen(!isOpen); return; }
    if (hit('navUserSignup') || hit('navUserVerify')) { e.stopPropagation(); setOpen(false); openSignup(); return; }
    if (hit('navUserOut')) {
      e.stopPropagation();
      try { fetch(BRIDGE + '/auth/logout', { method: 'POST', credentials: 'include' }); } catch (err) { }
      var p = load();
      p.nick = ''; p.email = ''; p.avatar = '';   /* 2026-10-14 用户裁决：只清这几项，保留 list/ts/skip 等偏好；2026-10-29 补清头像 */
      store(p);
      render();
      /* 2026-10-14：还得通知**当前页** —— 有些页（/pages/my-designs）屏幕上挂着
         「Welcome back / 我的设计清单 / 入口卡」，不清掉就是「退出后还看得到我的东西」。 */
      try { document.dispatchEvent(new CustomEvent('hd-logout')); } catch (err) { }
      return;
    }
    if (!inRoot) setOpen(false);      /* 点外部 = 收起 */
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) setOpen(false); });

  render();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', render);
  /* 跨标签页改了档案 ⇒ 同步；从 bfcache 回来 ⇒ 重画 */
  window.addEventListener('storage', function (e) { if (!e || e.key === KEY) render(); });
  window.addEventListener('pageshow', render);
  /* 同页改档案（设计台 onboarding 保存 / 退出）后由调用方刷新 —— 见 design-canvas 的 hdcoSaveObj */
  window.__hdNavUserRefresh = render;
})();
